/**
 * CTA Button Position Handler
 * Button stays fixed 20px from bottom until it reaches 120px after the stop element,
 * then switches to absolute positioning (no scroll updates needed).
 *
 * @package oska
 */

const BOTTOM_FIXED = 20; // Fixed distance from viewport bottom
const OFFSET_AFTER_STOP = 120; // Button top position offset from stop element top

export default function initCtaButton() {
  const btn = document.querySelector(".js-cta-btn");
  const stopElement = document.querySelector("[data-cta-stop]");

  if (!btn || !stopElement) {
    return;
  }

  const btnHeight = btn.offsetHeight;
  let isAbsolute = false;

  function getStopElementBottom() {
    const rect = stopElement.getBoundingClientRect();
    return rect.bottom + window.scrollY;
  }

  function updateButtonPosition() {
    const viewportHeight = window.innerHeight;
    const scrollY = window.scrollY;
    const stopBottom = getStopElementBottom();

    // Calculate where button bottom would be if fixed at bottom
    const btnBottomIfFixed = scrollY + viewportHeight - BOTTOM_FIXED;

    // Button top position when absolute (120px after stop element bottom)
    const absoluteBtnTop = stopBottom + OFFSET_AFTER_STOP;
    const absoluteBtnBottom = absoluteBtnTop + btnHeight;

    if (btnBottomIfFixed > absoluteBtnBottom) {
      // Button would go past stop position - switch to absolute
      if (!isAbsolute) {
        btn.classList.remove("fixed");
        btn.classList.add("absolute");
        btn.style.bottom = "auto";
        btn.style.top = absoluteBtnTop + "px";
        isAbsolute = true;
      }
    } else {
      // Button can be fixed at bottom
      if (isAbsolute) {
        btn.classList.remove("absolute");
        btn.classList.add("fixed");
        btn.style.top = "auto";
        btn.style.bottom = BOTTOM_FIXED + "px";
        isAbsolute = false;
      }
    }
  }

  // Update on scroll and resize
  window.addEventListener("scroll", updateButtonPosition, { passive: true });
  window.addEventListener(
    "resize",
    () => {
      // Recalculate absolute position on resize
      if (isAbsolute) {
        const stopBottom = getStopElementBottom();
        btn.style.top = stopBottom + OFFSET_AFTER_STOP + "px";
      }
      updateButtonPosition();
    },
    { passive: true },
  );

  // Initial position
  updateButtonPosition();
}
